module.exports = __webpack_public_path__ + "img/img-1.6c0f5791.svg";